export const UPDATE_OPERATOR_REQUEST = "UPDATE_OPERATOR_REQUEST";
export const UPDATE_OPERATOR_SUCCESS = "UPDATE_OPERATOR_SUCCESS";
export const UPDATE_OPERATOR_FAILURE = "UPDATE_OPERATOR_FAILURE";
